.tabs {
  display: none;

  @media screen and (min-width: $bp-medium) {
    display: flex;
    border-inline-start: 1px var(--bg-color-dark-black) solid;
    overflow-x: auto;
    overflow-y: hidden;

    ::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;
  }
}
